import { render } from "./App.vue?vue&type=template&id=1ba924ae&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1ba924ae&scoped=true&lang=css"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/projects-manager/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba924ae"]])

export default __exports__